import { render, staticRenderFns } from "./Form04_151_tab1.vue?vue&type=template&id=57049a14&scoped=true&"
import script from "./Form04_151_tab1.vue?vue&type=script&lang=js&"
export * from "./Form04_151_tab1.vue?vue&type=script&lang=js&"
import style0 from "./Form04_151_tab1.vue?vue&type=style&index=0&id=57049a14&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57049a14",
  null
  
)

export default component.exports